import React, { useState } from 'react';
import Spacer from '../../../../../components/presentational/Spacer';
import styled, { StylesProps } from '../../../../../lib/styles';

import faqBlockStyles from './FAQBlock_styles';

import { FAQItem } from './FAQItem';

export interface FAQBlockData {
  type: 'faq_block';
  faqs: any;
}

export interface FAQBlockProps {
  block: FAQBlockData;
}

const FAQBlock = ({ block: { faqs }, styles }) => {
  const [isOpen, setIsOpen] = useState('');

  return (
    <div className={styles.container}>
      <Spacer width={1160} space={['m', 'l']}>
        <div className={styles.container}>
          {faqs.map((faq, index) => {
            return (
              <FAQItem
                styles={styles}
                faq={faq}
                key={index}
                index={index}
                setIsOpen={setIsOpen}
                active={isOpen === index}
              />
            );
          })}
        </div>
      </Spacer>
    </div>
  );
};

export default styled(faqBlockStyles)(FAQBlock);
